import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalXoa } from "./ModalXoa";
import QuanLyThuChiHopDongApi from "service/quanLyThuChiHopDongApi";
export const BtnXoa = ({ item }) => {
  const [show, setShow] = useState(false);
  const [isXoa, setIsXoa] = useState(1);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Xoá"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img
            style={{ marginLeft: "5px" }}
            src="/app-assets/images/icon-xoa-v2.png"
          />
        </PopoversBootrap>
      </a>
      {show && <ModalXoa show={show} onHide={handleClose} Id={item.Id} />}
    </>
  );
};
